/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Approval_RequiredInputs */

const en_admin_resource_form_approval_required = /** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval required for visitors`)
};

const de_admin_resource_form_approval_required = /** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigung erforderlich für Besucher`)
};

const es_admin_resource_form_approval_required = /** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobación requerida para las reservas de visitantes`)
};

const fr_admin_resource_form_approval_required = /** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approbation requise pour les visiteurs`)
};

const nl_admin_resource_form_approval_required = /** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goedkeuring vereist voor bezoekers`)
};

/** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */
const it_admin_resource_form_approval_required = en_admin_resource_form_approval_required;

/** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */
const pt_br2_admin_resource_form_approval_required = en_admin_resource_form_approval_required;

/** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */
const pl_admin_resource_form_approval_required = en_admin_resource_form_approval_required;

/** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */
const hu_admin_resource_form_approval_required = en_admin_resource_form_approval_required;

/** @type {(inputs: Admin_Resource_Form_Approval_RequiredInputs) => LocalizedString} */
const ro_admin_resource_form_approval_required = en_admin_resource_form_approval_required;

/**
* | output |
* | --- |
* | "Approval required for visitors" |
*
* @param {Admin_Resource_Form_Approval_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_approval_required = /** @type {((inputs?: Admin_Resource_Form_Approval_RequiredInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Approval_RequiredInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_approval_required(inputs)
	if (locale === "de") return de_admin_resource_form_approval_required(inputs)
	if (locale === "es") return es_admin_resource_form_approval_required(inputs)
	if (locale === "fr") return fr_admin_resource_form_approval_required(inputs)
	if (locale === "nl") return nl_admin_resource_form_approval_required(inputs)
	if (locale === "it") return it_admin_resource_form_approval_required(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_approval_required(inputs)
	if (locale === "pl") return pl_admin_resource_form_approval_required(inputs)
	if (locale === "hu") return hu_admin_resource_form_approval_required(inputs)
	return ro_admin_resource_form_approval_required(inputs)
});
export { admin_resource_form_approval_required as "admin.resource_form.approval_required" }